import { render, staticRenderFns } from "./TheAppLogo.vue?vue&type=template&id=0d7b28e1&"
import script from "./TheAppLogo.vue?vue&type=script&lang=js&"
export * from "./TheAppLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports